var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dealer-header"},[_c('div',{staticClass:"dealer-header__name"},[_vm._v(_vm._s(_vm.name || '—'))]),(_vm.hqid)?_c('div',{staticClass:"dealer-header__hqid"},[_vm._v("HQID: "+_vm._s(_vm.hqid))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }